import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=0a13ec96&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=0a13ec96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a13ec96",
  null
  
)

export default component.exports